import React from "react";
import "./AboutGameStyle.scss";
import { aboutGameTextContent } from "./constant/index";

const AboutGameSection = ({
  headingText,
  paragraphText,
  listText,
  listItemTitle,
}) => {
  return (
    <section className="about-game-section">
      <div className="about-game-wrap">
        <h1 className="heading-text">
          {headingText || aboutGameTextContent.headingText}
        </h1>
        {paragraphText && <p className="para-text">{paragraphText}</p>}
        <ul className="list-text">
          {listItemTitle && (
            <li className="list-item list-item-title">{listItemTitle}</li>
          )}
          {listText?.map((item, index) => (
            <li className="list-item" key={index}>
              {item.listItem}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default AboutGameSection;
